
import WithModel from '@/mixins/withModel';
import * as OM from '@/model'
import { mixins, Options, Vue } from 'vue-class-component';

@Options({})
export default class fiscalData extends mixins(WithModel) {

    declare localValue: OM.BaseUser;

}
